import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { AwardIcon, GlobeIcon, MicIcon } from './icons/LineIcons';
const paragraphs = ['Norberth Pérez es comunicador, locutor, conductor de televisión, creador de contenido y estratega en marketing emocional, con más de 30 años de trayectoria en radio, televisión, prensa y medios digitales.', 'Ganador de un Emmy Award y cinco Telly Awards, ha entrevistado a reconocidas figuras de América Latina. También fue seleccionado por la Embajada de Sudáfrica en Caracas como la voz oficial en español de Nelson Mandela para uno de sus mensajes más emblemáticos.', 'Desde Atlanta, lidera NORBERTH Presenta, un espacio donde líderes, artistas y emprendedores comparten historias humanas que inspiran, conectan y generan impacto.'];
const highlights = [{
  icon: MicIcon,
  label: 'Más de 30 años de trayectoria'
}, {
  icon: AwardIcon,
  label: 'Emmy Award y cinco Telly Awards'
}, {
  icon: GlobeIcon,
  label: 'NORBERTH Presenta desde Atlanta'
}];
export function Biography() {
  return <section id="biografia" className="relative w-full overflow-hidden bg-graphite py-20 sm:py-24 lg:py-32" aria-labelledby="biografia-title" data-id="element-31" data-mp="3mm35fy5wpxo1">
      <div aria-hidden="true" className="pointer-events-none absolute -right-24 top-1/4 hidden h-72 w-72 rounded-full bg-gold/[0.06] blur-3xl lg:block" data-id="element-32" data-mp="3ikrkw71w42mp" />

      <div className="relative mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20 lg:px-10" data-id="element-33" data-mp="e4zxhcz8ac9b">
        <div data-id="element-34" data-mp="a5hmb8x7lfjo">
          <SectionHeading eyebrow="Biografía" title={<span id="biografia-title" data-id="element-36" data-mp="5c5015g05ku3">
                Norberth <span className="text-gold" data-id="element-37" data-mp="femaoro71bu">Pérez</span>
              </span>} data-id="element-35" data-mp="a6so5373gd85" />

          <ul className="mt-10 space-y-4" data-id="element-38" data-mp="xush89rvofpw">
            {highlights.map(({
            icon: Icon,
            label
          }, index) => <motion.li key={label} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.5
          }} transition={{
            duration: 0.45,
            delay: index * 0.08
          }} className="flex items-center gap-4 rounded-card border border-white/[0.07] bg-anthracite px-5 py-4 transition-all duration-300 hover:border-gold/40 hover:shadow-[0_20px_50px_-30px_rgba(245,197,24,0.5)]" data-id="element-39" data-mp="t3acdamqhuzn" data-mpi={index}>
                <span className="grid h-10 w-10 shrink-0 place-items-center rounded-md border border-gold/25 bg-ink text-gold" data-id="element-40" data-mp="t89ss4bk1ufx">
                  <Icon className="h-5 w-5" data-id="element-41" data-mp="y9p8dguyr8qx" />
                </span>
                <span className="font-sans text-sm leading-snug text-white/90" data-id="element-42" data-mp="k9o7i1ep81bg">
                  {label}
                </span>
              </motion.li>)}
          </ul>
        </div>

        <div className="relative" data-id="element-43" data-mp="2enpa8xddd8gt">
          <span aria-hidden="true" className="absolute left-0 top-1.5 hidden h-full w-px bg-gradient-to-b from-gold/60 via-steel/60 to-transparent lg:block" data-id="element-44" data-mp="2ekjhn85j7ogc" />
          <div className="space-y-6 lg:pl-10" data-id="element-45" data-mp="715l8f69uz6e">
            {paragraphs.map((paragraph, index) => <motion.p key={paragraph.slice(0, 24)} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.4
          }} transition={{
            duration: 0.55,
            delay: index * 0.1
          }} className={index === 0 ? 'text-base leading-relaxed text-white sm:text-lg' : 'text-sm leading-relaxed text-ash sm:text-base'} data-id="element-46" data-mp="31558q3iyfx8" data-mpi={index}>
                {paragraph}
              </motion.p>)}
          </div>
        </div>
      </div>
    </section>;
}